'use strict';

module.exports = /*@ngInject*/
function(
        $timeout,
        $q
    ) {
    return {
        scope: {
            defaultText: '=',
            confirmationText: '=',
            /**
             * expect either an object containing fn and params props
             * or a function
             * @type {object || function}
             */
            action: '=?'    // if a function is passed in, it will exercute then animate the button color
        },
        template:   '<div class="confirmation-button">' +
                        '<span class="default-text">{{ defaultText }}</span>' +
                        '<span class="confirmation-text">{{ confirmationText }}</span>' +
                    '</div>',
        link: function($scope, $element, $attrs) {
            var confirmationClass = 'confirmation-button-active';
            var result;
            var fn;
            var params;

            fn = $scope.action.fn || $scope.action;
            params = $scope.action.params || [];

            $element.click(function() {
                result = fn.apply(null, params);

                // $q.when makes result always a promise
                $q.when(result)
                    .then(function(data) {
                        $element.addClass(confirmationClass);
                        $timeout(function() {
                            $element.removeClass(confirmationClass);
                        }, 2000);
                    });
            });
        }
    };
};
